import React, {Component} from 'react';
import LanguageSelect from '../LanguageSelect';

export class RightSide extends Component {
    constructor(props) {
        super(props);

        this.showAuthModal = this.showAuthModal.bind(this);
        this.showRegModal = this.showRegModal.bind(this);
        this.logout = this.logout.bind(this);
        this.handleRentSaleClick = this.handleRentSaleClick.bind(this);
        this.getDisplayName = this.getDisplayName.bind(this);
    }

    showAuthModal(event, isShowAuthModal) {
        event.preventDefault();

        this.props.showAuthModal(isShowAuthModal);
    }

    showRegModal(event, isShowRegModal) {
        event.preventDefault();

        this.props.showRegModal(isShowRegModal);
    }

    logout(event) {
        event.preventDefault();

        this.props.logout();
    }

    handleRentSaleClick(event) {
        event.preventDefault();


        this.props.handleRentSaleClick();
    }

    getDisplayName() {
        let {currentUser} = this.props;

        if (currentUser == null || currentUser == undefined) {
            return '';
        }

        if (currentUser.firstName != null && currentUser.lastName != null) {
            return currentUser.firstName + " " + currentUser.lastName;
        }
        if (currentUser.firstName != null && currentUser.lastName == null) {
            return currentUser.firstName;
        }
        if (currentUser.firstName == null && currentUser.lastName != null) {
            return currentUser.lastName;
        }

        return currentUser.email;
    }

    render() {
        let {currentUser, i18n} = this.props;
        return (
            <div className="header-rightside">
                {currentUser.accessToken === null &&
                <div className="login-box d-flex">
                    <a href="" onClick={(event) => this.showAuthModal(event, true)}
                       className="link link-login">{i18n['layout.loginOwner']}</a>
                    <span>|</span>
                    <a href="" onClick={(event) => this.showRegModal(event, true)}
                       className="link link-reg">{i18n['layout.register']}</a>
                </div>}

                {currentUser.accessToken != null &&
                <div className="login-box d-flex">
                    <div className='link-box'>
                        <a href={"/crm"} className="user-box link">
                            <img src={"/files/users/" + currentUser.userId + "/avatar"} alt=""
                                 className="user-box-img"/>
                            <span
                                className="user-box-text">{this.getDisplayName()}</span>
                        </a>
                        <div className="dropdown">
                            <ul>
                                <li>
                                    <a href={"/crm/property-manager"}>{i18n['crm.menu.user.propertyManager']}</a>
                                </li>

                                <li>
                                    <a href={"/crm/booking-manager"}>{i18n['crm.menu.user.bookingManager']}</a>
                                </li>

                                <li>
                                    <a href={"/crm/channel-manager"}>{i18n['crm.menu.user.channelManager']}</a>
                                </li>

                                <li>
                                    <a href={"/crm/calendar"}>{i18n['crm.menu.user.calendar']}</a>
                                </li>

                                <li>
                                    <a href={"/crm/inbox"}>{i18n['crm.menu.user.inbox']}</a>
                                </li>

                                <li>
                                    <a href={"/crm/profile"}>{i18n['crm.menu.user.profile']}</a>
                                </li>

                                <li>
                                    <a href={"/crm/accounting"}>{i18n['crm.menu.user.accounting']}</a>
                                </li>

                                <li>
                                    <a href={"/crm/guests"}>{i18n['crm.menu.user.clientManager']}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <span className="mrgn-h-xs">|</span>
                    <a href="" onClick={::this.logout}
                       className="link link-login">{i18n['layout.logout']}</a>
                </div>
                }

                <LanguageSelect/>
                <a href="" className="btn" onClick={::this.handleRentSaleClick}>
                    {i18n['layout.rentSale']}
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Base/header/RightSide.js